import { module } from 'modujs';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
        this.text = [...this.el.querySelectorAll('[data-text-effect]')];
    }

    init() {
        if (!this.text.length) return;

        this.text.forEach((item) => {
            gsap.fromTo(
                item,
                {
                    y: 40,
                    opacity: 0,
                },
                {
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    ease: 'power3.out',
                    scrollTrigger: {
                        trigger: item,
                        start: 'top 85%',
                        once: true,
                    },
                }
            );
        });
    }
}